/* PUSU – Löydä oma PUSU: valinta-apu, ankkuroidut vertailut ja analytiikkatapahtumat.
   Tekstit tulevat HTML:stä; tässä tiedostossa ei ole asiakkaalle näkyviä merkkijonoja. */
(() => {
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Tapahtumat nykyiseen Shopify-analytiikkaan (asiakastapahtumat / custom pixel). Ei omaa seurantaa.
  const track = (name, data) => {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (e) { /* analytiikka ei saa rikkoa sivua */ }
  };

  const init = (root) => {
    if (!root || root.dataset.pgReady === '1') return;
    root.dataset.pgReady = '1';
    const locale = root.dataset.locale || document.documentElement.lang || '';
    let lastChoice = null;

    /* Valinta-apu */
    const buttons = [...root.querySelectorAll('[data-pg-choice]')];
    const results = [...root.querySelectorAll('[data-pg-result]')];
    // Suosituskuvat ladataan sivun latauduttua, jotta valinnan vaihto näyttää kuvan heti.
    const warm = () => results.forEach((r) => r.querySelectorAll('img[loading="lazy"]').forEach((i) => { i.loading = 'eager'; }));
    if (document.readyState === 'complete') warm(); else window.addEventListener('load', warm, { once: true });
    const select = (index, opts = {}) => {
      buttons.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.pgChoice === String(index))));
      results.forEach((r) => { r.hidden = r.dataset.pgResult !== String(index); });
      const btn = buttons.find((b) => b.dataset.pgChoice === String(index));
      lastChoice = btn ? btn.textContent.trim() : null;
      try { history.replaceState(Object.assign({}, history.state, { pgChoice: String(index) }), ''); } catch (e) {}
      if (opts.user) {
        track('pusu_guide_choice', { situation: lastChoice, locale });
        // Puhelimessa tuodaan tulos näkyviin; fokus jää valittuun painikkeeseen.
        const shown = results.find((r) => !r.hidden);
        if (shown && window.matchMedia('(max-width: 899px)').matches) {
          const rect = shown.getBoundingClientRect();
          if (rect.top < 0 || rect.top > window.innerHeight * 0.6) {
            shown.scrollIntoView({ block: 'start', behavior: reduceMotion() ? 'auto' : 'smooth' });
          }
        }
      }
    };
    buttons.forEach((b) => b.addEventListener('click', () => select(b.dataset.pgChoice, { user: true })));
    const saved = history.state && history.state.pgChoice;
    if (saved && buttons.some((b) => b.dataset.pgChoice === saved)) select(saved);

    /* Ankkurit avaavat oikean vertailun */
    const openTarget = (hash, scroll) => {
      if (!hash || hash.length < 2) return;
      let el;
      try { el = root.querySelector(decodeURIComponent(hash)); } catch (e) { return; }
      if (!el) return;
      // Etusivun käyttötapalinkit (#pg-result-N) avaavat valinta-avun oikealla valinnalla.
      if (el.dataset && el.dataset.pgResult !== undefined) {
        select(el.dataset.pgResult);
        const choice = root.querySelector('#pc-choice');
        if (scroll && choice) choice.scrollIntoView({ block: 'start', behavior: 'auto' });
        return;
      }
      const det = el.tagName === 'DETAILS' ? el : el.closest('details');
      if (det && !det.open) det.open = true;
      if (scroll) el.scrollIntoView({ block: 'start', behavior: 'auto' });
    };
    root.addEventListener('click', (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (a && root.contains(a)) openTarget(a.getAttribute('href'), false);
    });
    window.addEventListener('hashchange', () => openTarget(location.hash, true));
    if (location.hash) openTarget(location.hash, true);

    /* Hero: valinta-avun avaus */
    root.querySelectorAll('[data-pg-open]').forEach((a) => a.addEventListener('click', () => {
      track('pusu_guide_choice_open', { source: a.dataset.pgOpen, locale });
    }));

    /* Vertailun avaaminen */
    root.querySelectorAll('details[data-pg-topic]').forEach((d) => d.addEventListener('toggle', () => {
      if (d.open) track('pusu_guide_compare_open', { topic: d.dataset.pgTopic, locale });
    }));

    /* Tuotelinkin klikkaus */
    root.addEventListener('click', (e) => {
      const a = e.target.closest('a[data-pg-model]');
      if (!a || !root.contains(a)) return;
      const topic = a.closest('details[data-pg-topic]');
      track('pusu_guide_product_click', {
        model: a.dataset.pgModel,
        location: a.dataset.pgLoc,
        topic: topic ? topic.dataset.pgTopic : null,
        situation: a.dataset.pgLoc === 'valinta-apu' ? lastChoice : null,
        locale,
      });
    });
  };

  const boot = () => document.querySelectorAll('[data-pusu-guide]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-pusu-guide]').forEach(init));
})();
